import axios from "axios";
import React, { Fragment, useEffect, useMemo, useState, useRef } from "react";
import { Container, Row, Col, Stack, Image, Modal, Form } from "react-bootstrap";
import { Button, Popup, Icon, Label, Divider, Checkbox, Loader, Dimmer } from "semantic-ui-react";
import moment from "moment";
import { AgGridReact } from "ag-grid-react";
import { DateRangePicker, DatePicker } from "rsuite";
import { Toast } from "../component/Toast";
import ReactQuill from 'react-quill';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'react-quill/dist/quill.snow.css';
import ImageResize from "quill-image-resize-module-react";
import BlotFormatter from "quill-blot-formatter";
import Quill from "quill";
Quill.register("modules/imageResize", ImageResize);
Quill.register("modules/blotFormatter", BlotFormatter);

const Blog = () => {
    const formatDate = (date) => {
        if (!date) return "";
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };
    const [blogs, setBlogs] = useState([]);
    const [loadingContent, setLoadingContent] = useState(false)
    const [thumbnail, setThumbnail] = useState(null);
    const [contentImage, setContentImage] = useState(null);
    const [isLoadingUpload, setIsLoadingUpload] = useState(false);
    const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
    const [isLoadingDelete, setIsLoadingDelete] = useState(false);
    const [selectedDelete, setSelecedDelete] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState("");
    const [isLoadingUpdate, setIsLoadingUpdate] = useState(false);
    const [thumbnailModal, setThumbnailModal] = useState({
        show: false,
        rowId: null,
        file: null,
        preview: null,
        oldFile: null,
    });

    const [contentModal, setContentModal] = useState({
        show: false,
        rowId: null,
        file: null,
        preview: null,
        oldFile: null,
    });
    
    const [loadGenerateXML, setLoadGenerateXml] = useState(false);

    const session = localStorage.getItem('cms_session') ? JSON.parse(localStorage.getItem('cms_session')) : null;
    const [dateRange, setDateRange] = useState(() => {
        if (window.sessionStorage.getItem('startBlog')) {
            return [
                new Date(JSON.parse(window.sessionStorage.getItem('startBlog'))),
                new Date(JSON.parse(window.sessionStorage.getItem('endBlog')))
            ]
        } else {
            return [
                new Date(moment().startOf('month')),
                new Date(moment()),
            ]
        }
    })
    const [publishDate, setPublishDate] = useState(new Date())
    const [startDate, setStartDate] = useState(formatDate(dateRange[0]))
    const [endDate, setEndDate] = useState(formatDate(dateRange[1]))
    const [search, setSearch] = useState("")
    const [user, setUser] = useState(null)
    //   const date = [startDate, endDate]
    const [selectedRows, setSelectedRows] = useState([]);
    const [ids, setIds] = useState([])
    const [loading, setLoading] = useState(true);
    const gridRef = useRef(null);
    const gridApiRef = useRef(null);


    // Modal Add/Edit
    const [showModal, setShowModal] = useState(false);
    const [editData, setEditData] = useState(null);

    useEffect(() => {
        if (editData?.start_date) {
            setPublishDate(new Date(editData.start_date));
        } else {
            setPublishDate(new Date());
        }
    }, [editData]);

    const successAlert = (title) => {
        Toast.fire({
            icon: 'success',
            title: `${title}` || 'Request running successfully',
            timer: 5000,
            timerProgressBar: true,
            showConfirmButton: false,
            showCloseButton: false
        });
    }

    const errorAlert = (title, errorObj, text = null) => {
        // If errorObj has "error" key, use that
        const errors = errorObj?.error || errorObj;

        // Build HTML list of errors
        let errorList = '';
        if (errors && typeof errors === 'object') {
            errorList = `<ul style="text-align:left; margin:0; padding-left:20px;">
        ${Object.entries(errors)
                    .map(([field, msg]) => `<li>${msg}</li>`)
                    .join('')}
        </ul>`;
        }

        Toast.fire({
            icon: 'error',
            title: title || 'Unknown error occurred',
            text: text || "",
            html: errorList || '',
            timer: null,
            timerProgressBar: false,
            showConfirmButton: false,
            showCloseButton: true
        });
    };

    const HtmlCellRenderer = (props) => {
        return <div dangerouslySetInnerHTML={{ __html: props.value }} />;
    };

    const handleClose = () => {
        setShowModal(false);
        setEditData(null);
        setThumbnail(null);
        setContentImage(null);
        setContent("");
    };


    const handleShowAdd = () => {
        setLoadingContent(false);
        setEditData(null);
        setContent("");
        setShowModal(true);
    };

    const handleShowEdit = (data) => {
        setEditData(data);
        getBlogsByID(data.id)
        setShowModal(true);
    };

    useEffect(() => {
        if (Array.isArray(selectedRows)) {
            const selectedIds = selectedRows.map((row) => row.id);
            setIds(selectedIds);
        }
    }, [selectedRows]);

    // Fetch Blog
    const getBlogs = async () => {
        setLoading(true);
        // setBlogs([]);

        const startDate = formatDate(dateRange[0]);
        const endDate = formatDate(dateRange[1]);

        await axios({
            method: "GET",
            url: `${global.SRV}api_hoops_cms/controler/blog.php`,
            headers: { "Content-Type": "application/json" },
            params: {
                ...(search ? { search } : { "date[]": [startDate, endDate] }),
                all_status: "Y",
                limit: 50,
            },
        })
            .then((res) => {
                setBlogs(res.data.data);
                successAlert(res.data?.message);
            })
            .catch((err) => {
                console.log(err)
                errorAlert(`Error ${err.response?.status}: ${err.response?.data.message}`, null);
            }).finally(() => {
                setLoading(false)
            });
    };

    const getBlogsByID = async (id) => {
        setLoadingContent(true);
        await axios({
            method: "GET",
            url: `${global.SRV}api_hoops_cms/controler/blog.php`,
            headers: { "Content-Type": "application/json" },
            params: {
                id: id,
                all_status: "Y",
            },
        })
            .then((res) => {
                setContent(res.data.data?.description || "");
                // successAlert(res.data?.message);
            })
            .catch((err) => {
                console.log(err)
                errorAlert(`Error ${err.response?.status}: ${err.response?.data.message}`, null);
            }).finally(() => {
                setLoadingContent(false)
            });
    };

    const handleDelete = async (id = null) => {
        if (!window.confirm("Are you sure to delete these data?")) return;
        setIsLoadingDelete(true)
        setSelecedDelete(id)
        const idsInt = id !== null ? [Number(id)] : ids.map(Number);
        await axios({
            method: "DELETE",
            url: `${global.SRV}api_hoops_cms/controler/blog.php`,
            headers: { "Content-Type": "application/json" },
            data: { ids: idsInt },
        }).then((res) => {
            successAlert(res.data?.message)
            getBlogs();
        }).catch((error) => {
            errorAlert(`Error ${error.response?.status}: ${error.response?.data.message}`, null);
        }).finally(() => {
            setIsLoadingDelete(false)
            setSelecedDelete(null)
        })
            ;
    };

    const handleUpdateStatus = async () => {
        setIsLoadingUpdate(true);
        const idsInt = ids.map(Number);
        await axios({
            method: "PUT",
            url: `${global.SRV}api_hoops_cms/controler/blog.php`,
            headers: { "Content-Type": "application/json" },
            data: { ids: idsInt, is_active: Number(selectedStatus), modified_by: session?.name },
        }).then((res) => {
            successAlert(res.data?.message)
            getBlogs();
        }).catch((error) => {
            errorAlert(`Error ${error.response?.status}: ${error.response?.data.message}`, null);
        }).finally(() => {
            setIsLoadingUpdate(false)
            selectedStatus("")
        })
    };

    const onSelectionChanged = (params) => {
        setSelectedRows(params.api.getSelectedRows());
    };

    // Renderer Thumbnail
    const rendererThumbnail = (params) => {
        const data = params.data;
        return (
            <Stack direction="horizontal" gap={2}>
                <Image
                    src={data.image_thumbnail || "https://placehold.co/50x40/cccccc/000000?text=No+Image"}
                    width={50}
                    height={40}
                    rounded
                />

                <a
                    href={`https://hoopsindonesia.co.id/blog/${data.slug}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-truncate"
                    style={{ maxWidth: 200, display: "inline-block" }}
                >
                    {data.title}
                </a>
            </Stack>
        );
    };

    const rendererStatus = (params) => {
        const { data, api } = params;

        const handleToggle = async () => {
            data.loading = true;
            api.refreshCells({ rowNodes: [params.node], force: true });

            const newStatus = data.is_active === "1" ? "0" : "1";
            const formData = new FormData();
            formData.append("is_active", Number(newStatus));
            formData.append("modifier", session?.name);

            try {
                const res = await axios.post(
                    `${global.SRV}api_hoops_cms/controler/blog.php?id=${data.id}`,
                    formData,
                    { headers: { "Content-Type": "multipart/form-data" } }
                );
                data.is_active = newStatus;
                data.modified_by = session?.name;
                successAlert(res.data?.message);
            } catch (error) {
                console.error(error.response);
                errorAlert(`Error ${error.response?.status}: ${error.response?.data.message}`, { error: error.response?.data.errors });
            } finally {
                data.loading = false;
                api.refreshCells({ rowNodes: [params.node], force: true });
            }
        };


        return (
            <div style={{
                display: "flex",
                justifyContent: "center", // horizontal center
                alignItems: "center",     // vertical center
                gap: "6px",
                width: "100%",
                height: "100%",
            }}>
                <Checkbox
                    toggle
                    disabled={data.loading}
                    checked={data.is_active === "1"}
                    onChange={handleToggle}
                />
            </div>
        );
    };

    const handleThumbnailOpen = (rowId, oldFile) => {
        setThumbnailModal({ show: true, rowId, file: null, preview: null, oldFile: oldFile });
    };

    const handleThumbnailClose = () => {
        setThumbnailModal({ show: false, rowId: null, file: null, preview: null, oldFile: null });
    };

    const handleContentOpen = (rowId, oldFile) => {
        setContentModal({ show: true, rowId, file: null, preview: null, oldFile: oldFile });
    };

    const handleContentClose = () => {
        setContentModal({ show: false, rowId: null, file: null, preview: null, oldFile: null });
    };

    const handleThumbnailChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () =>
                setThumbnailModal((prev) => ({ ...prev, preview: reader.result, file }));
            reader.readAsDataURL(file);
        }
    };

    const handleContentChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () =>
                setContentModal((prev) => ({ ...prev, preview: reader.result, file }));
            reader.readAsDataURL(file);
        }
    };

    const handleThumbnailUpload = async () => {
        if (!thumbnailModal.file || !thumbnailModal.rowId) return;
        const formData = new FormData();
        formData.append("thumbnail", thumbnailModal.file);
        formData.append("modifier", session?.name);
        setIsLoadingUpload(true)
        try {
            const res = await axios.post(
                `${global.SRV}api_hoops_cms/controler/blog.php?id=${thumbnailModal.rowId}`,
                formData,
                { headers: { "Content-Type": "multipart/form-data" } }
            );
            handleThumbnailClose();
            getBlogs();
            setIsLoadingUpload(false)
            successAlert(res.data?.message);
        } catch (err) {
            console.error(err);
            setIsLoadingUpload(false)
            errorAlert(`Error ${err.response?.status}: ${err.response?.data.message}`, { error: err.response?.data.errors });

        }
    };

    const handleContentUpload = async () => {
        if (!contentModal.file || !contentModal.rowId) return;
        const formData = new FormData();
        formData.append("content", contentModal.file);
        formData.append("modifier", session?.name);
        setIsLoadingUpload(true)
        try {
            const res = await axios.post(
                `${global.SRV}api_hoops_cms/controler/blog.php?id=${contentModal.rowId}`,
                formData,
                { headers: { "Content-Type": "multipart/form-data" } }
            );
            handleContentClose();
            getBlogs();
            setIsLoadingUpload(false)
            successAlert(res.data?.message);
        } catch (err) {
            console.error(err);
            setIsLoadingUpload(false)
            errorAlert(`Error ${err.response?.status}: ${err.response?.data.message}`, { error: err.response?.data.errors });

        }
    };


    // Renderer Action
    const rendererAction = ({ data }) => {
        const { id } = data;
        console.log(data.image_content)

        return (
            <div style={{ display: "flex", overflowX: "auto", whiteSpace: "nowrap", maxWidth: "150px" }}>
                <Button.Group size="mini" basic>
                    <Popup content="Edit" trigger={<Button icon="edit" onClick={() => handleShowEdit(data)} />} />
                    <Popup content="Change Thumbnail Image" trigger={<Button icon="image outline" onClick={() => handleThumbnailOpen(id, data.image_thumbnail)} />} />
                    <Popup content="Change Content Image" trigger={<Button icon="camera" onClick={() => handleContentOpen(id, data.image_content)} />} />
                    <Popup content="Delete" trigger={<Button disabled={isLoadingDelete} loading={selectedDelete === id && isLoadingDelete} icon="trash" onClick={() => handleDelete(id)} />} />
                </Button.Group>
            </div>
        );
    };


    // Column Defs
    const columnDefs = useMemo(() => {
        return [
            {
                headerCheckboxSelection: true,
                checkboxSelection: true,
                maxWidth: 50,
            },
            {
                headerName: "Thumbnail & Title",
                field: "title",
                cellRenderer: rendererThumbnail,
                filter: "agTextColumnFilter",
                sortable: true,
                minWidth: 300,
            },
            {
                headerName: "Author",
                field: "author",
                filter: "agTextColumnFilter",
                sortable: true,
                minWidth: 150,
            },
            {
                headerName: "Content",
                field: "description",
                cellRenderer: HtmlCellRenderer
            },
            {
                headerName: "Meta Title",
                field: "meta_title",
                filter: "agTextColumnFilter",
                sortable: true,
                minWidth: 300,
            },
            {
                headerName: "Meta Description",
                field: "meta_description",
                filter: "agTextColumnFilter",
                sortable: true,
                minWidth: 300,
            },
            selectedRows?.length <= 1
                ?
                {
                    headerName: "Activation",
                    field: "is_active",
                    cellRenderer: rendererStatus,
                    maxWidth: 120,
                } : null,
            {
                headerName: "Publish Date",
                field: "start_date",
                filter: "agTextColumnFilter",
                sortable: true,
                minWidth: 180,
            },
            // {
            //     headerName: "End Date",
            //     field: "end_date",
            //     filter: "agTextColumnFilter",
            //     sortable: true,
            //     minWidth: 180,
            // },
            {
                headerName: "Last Modified By",
                field: "modified_by",
                filter: "agTextColumnFilter",
                sortable: true,
                minWidth: 180,
            },
            {
                headerName: "Created At",
                field: "created_at",
                filter: "agDateColumnFilter",
                sortable: true,
                minWidth: 180,
            },
            selectedRows?.length <= 1
                ? {
                    headerName: "Action",
                    field: "action",
                    cellRenderer: rendererAction,    
                    suppressMenu: true,
                    cellStyle: { display: 'flex', alignItems: 'center' }
                }
                : null,
        ].filter(Boolean);
    }, [selectedRows]);


    // Form Submit (Add/Edit)
    const handleSubmit = async (formData) => {
        setIsLoadingSubmit(true)
        if (editData) { formData.append("modifier", session?.name) };
        const startDate = formatDate(publishDate);
        formData.append("start_date", startDate);
        formData.append("end_date", startDate);
        const method = editData ? "POST" : "POST";
        const url = editData
            ? `${global.SRV}api_hoops_cms/controler/blog.php?id=${editData.id}`
            : `${global.SRV}api_hoops_cms/controler/blog.php`;

        await axios({
            method,
            url,
            headers: { "Content-Type": "multipart/form-data" },
            data: formData,
        }).then((res) => {
            getBlogs();
            handleClose();
            successAlert(res.data?.message);
        }).catch((error) => {
            errorAlert(`Error ${error.response?.status}: ${error.response?.data.message}`, { error: error.response?.data.errors });
        }).finally(() => {
            setIsLoadingSubmit(false)
        });
    };


    const handleChangeDate = (e) => {
        setDateRange(e)
        window.sessionStorage.setItem('startBlog', JSON.stringify(e[0]))
        window.sessionStorage.setItem('endBlog', JSON.stringify(e[1]))
    }

    const handleChangePublishDate = (date) => {
        setPublishDate(date);
    }

    useEffect(() => {
        setStartDate(formatDate(dateRange[0]))
        setEndDate(formatDate(dateRange[1]))
        getBlogs();
    }, [dateRange]);

    useEffect(() => {
        getBlogs();
    }, []);

    //   useEffect(() => {
    //     if (editData) {
    //         getBlogsByID(editData.id)
    //     } else {
    //         setContent(""); 
    //     }
    //     }, [editData]);

    useEffect(() => {
        if (!gridApiRef.current) return;  // check the API
        if (loading) {
            gridApiRef.current.showLoadingOverlay();
        } else if (blogs.length === 0) {
            gridApiRef.current.showNoRowsOverlay();
        } else {
            gridApiRef.current.hideOverlay();
        }
    }, [loading, blogs]);



    const [content, setContent] = useState(editData?.description || "");
    const quillModules = {
        toolbar: [
            [{ header: [1, 2, 3, false] }],
            ["bold", "italic", "underline", "strike"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ align: [] }],
            ["link", "image"],
            ["clean"],
        ],
        imageResize: {
            parchment: Quill.import("parchment"),
            modules: ["Resize", "DisplaySize", "Toolbar"],
        },
        blotFormatter: {}, // Bisa drag & resize gambar
    };
    const quillFormats = [
        "header",
        "bold", "italic", "underline", "strike",
        "list", "bullet",
        "align", "link", "image",
    ];
    const onSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        formData.set("description", content); // Simpan HTML ke backend
        handleSubmit(formData);
    };

    
    const generateXML = () => {
        setLoadGenerateXml(true)
        axios({
            method: "GET",
            url: `https://hoopsindonesia.co.id/api_hoops/controler/generateXML.php`,
            headers: {
                'Content-Type': 'application/json',
            },
        })
        .then(res => {
            successAlert(res.data?.message);
        })
        .catch((err) => {
            console.log(err) 
            errorAlert(`Error ${err.response?.status}: ${err.response?.data.message}`);
        }).finally(() => {
            setLoadGenerateXml(false) 
        });
    }

    return (
        loading ?
            <Dimmer active inverted>
                <Loader>Please Wait</Loader>
            </Dimmer>
            :
            <Container fluid>
                <Row className="my-3 align-items-center">
                    <Col>
                        <h3 className="mb-0">Blog Management</h3>
                    </Col>
                    <Col className="text-end">
                    
                        <Button 
                            content="Generate Sitemap" 
                            onClick={() => generateXML()} 
                            color="green" 
                            loading={loadGenerateXML} 
                        />

                        <Button
                            primary
                            content="Add Blog"
                            icon="plus"
                            onClick={handleShowAdd}
                        />
                    </Col>
                </Row>

                <Row className="mb-3">
                    <Col>
                        <div className="d-flex justify-content-between align-items-center gap-3">
                            {/* Date Range Picker */}
                            <DateRangePicker
                                format="yyyy-MM-dd"
                                placement="bottomStart"
                                cleanable
                                defaultValue={dateRange}
                                value={dateRange}
                                onOk={handleChangeDate}
                                onClean={() =>
                                    setDateRange([
                                        new Date(moment().startOf("year")),
                                        new Date(moment()),
                                    ])
                                }
                            />
                            
                            {/* Search + Generate Button */}
                            <div className="d-flex gap-2">
                                <Form.Control
                                    type="text"
                                    name="search"
                                    size="mini"
                                    placeholder="Search blog..."
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                    style={{ maxWidth: "200px" }}
                                />
                                <Popup content={search.trim() === "" ? "Refresh" : "Search"} trigger={
                                    <Button
                                        variant="primary"
                                        color="orange"
                                        size="mini"
                                        icon={search.trim() === "" ? "refresh" : "search"}
                                        onClick={getBlogs}
                                    >
                                    </Button>
                                } />
                            </div>
                        </div>
                    </Col>
                </Row>

                <Divider />

                {/* AG Grid Table */}
                <div className="ag-theme-alpine" style={{ height: 500, width: "100%" }}>
                    {ids.length > 1 && (
                        <>
                            <Row className="mb-3 align-items-center">
                                <Col md="auto">
                                    <Button
                                        color="red"
                                        icon="trash"
                                        disabled={isLoadingDelete || isLoadingUpdate}
                                        content={isLoadingDelete ? "Deleting..." : "Delete Selected Data"}
                                        loading={isLoadingDelete}
                                        onClick={() => handleDelete()}
                                    />
                                </Col>

                                <Col md="auto">
                                    <Form
                                        onSubmit={(e) => {
                                            e.preventDefault();
                                            handleUpdateStatus();
                                        }}
                                    >
                                        <Row className="g-2 align-items-center">
                                            <Col xs="auto">
                                                <Form.Group className="mb-0">
                                                    <Form.Select
                                                        disabled={isLoadingDelete || isLoadingUpdate}
                                                        name="is_active"
                                                        value={selectedStatus}
                                                        onChange={(e) => setSelectedStatus(e.target.value)}
                                                    >
                                                        <option value="">-- Select Status --</option>
                                                        <option value="1">Active</option>
                                                        <option value="0">Inactive</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col xs="auto">
                                                <Button
                                                    color="blue"
                                                    icon="sync"
                                                    content={isLoadingUpdate ? "Updating..." : "Update Multiple Status"}
                                                    loading={isLoadingUpdate}
                                                    disabled={!selectedStatus || isLoadingUpdate || isLoadingDelete}
                                                    type="submit"
                                                />
                                            </Col>
                                        </Row>
                                    </Form>
                                </Col>
                            </Row>
                        </>
                    )}
                    <AgGridReact
                        ref={gridRef}
                        rowData={loading ? [] : blogs}
                        columnDefs={columnDefs}
                        overlayLoadingTemplate={`
                <div style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 100%;
                    flex-direction: column;
                ">
                    <div class="ui active inline loader" style="margin-bottom: 15px;"></div>
                    <span style="font-size: 16px; color: #555;">Loading, please wait...</span>
                </div>
            `}
                        overlayNoRowsTemplate={`
                <div style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 100%;
                    flex-direction: column;
                    color: #999;
                ">
                    No Data Found
                </div>
            `}
                        rowSelection="multiple"
                        pagination
                        paginationPageSize={10}
                        onSelectionChanged={onSelectionChanged}
                        animateRows
                        onGridReady={(params) => gridApiRef.current = params.api}
                    />
                </div>
                {/* Modal for Thumbnail Upload */}
                <Modal
                    show={thumbnailModal.show}
                    onHide={handleThumbnailClose}
                    size="lg"
                    centered
                    backdrop="static"
                    keyboard={true}
                >
                    <Modal.Header closeButton={!isLoadingUpload}>
                        <Modal.Title>Upload Thumbnail</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row className="mb-3 d-flex justify-content-evenly">
                            {/* Old Thumbnail */}
                            {thumbnailModal.oldFile && (
                                <Col md={6} className="text-center">
                                    <h6>Current Thumbnail</h6>
                                    <Image
                                        src={thumbnailModal.oldFile}
                                        alt="Old Thumbnail"
                                        fluid
                                        rounded
                                        style={{ maxHeight: "200px", objectFit: "cover", border: "1px solid #ddd", padding: "5px" }}
                                    />
                                </Col>
                            )}

                            {/* New Thumbnail Preview */}
                            <Col md={6} className="text-center">
                                <h6>New Image Preview</h6>
                                {thumbnailModal.preview ? (
                                    <Image
                                        src={thumbnailModal.preview}
                                        alt="Preview"
                                        fluid
                                        rounded
                                        style={{ maxHeight: "200px", objectFit: "cover", border: "1px solid #ddd", padding: "5px" }}
                                    />
                                ) : (
                                    <div
                                        style={{
                                            height: "200px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            border: "1px dashed #ccc",
                                            borderRadius: "5px",
                                            color: "#999",
                                        }}
                                    >
                                        Preview will appear here
                                    </div>
                                )}
                            </Col>
                        </Row>

                        {/* File Upload */}
                        <Row className="mt-3">
                            <Col>
                                <Form.Group>
                                    <Form.Label>Select New Image</Form.Label>
                                    <Form.Control
                                        type="file"
                                        accept="image/*"
                                        onChange={(e) => {
                                            const file = e.target.files[0];
                                            if (file) {
                                                if (file.size > 1024 * 1024) {
                                                    errorAlert("File is too large!", null, "Please upload an image smaller than 1 MB.")
                                                    setThumbnailModal({ ...thumbnailModal, file: null });
                                                    e.target.value = "";
                                                } else {
                                                    handleThumbnailChange(e)
                                                }
                                            }
                                        }}
                                    // onChange={handleThumbnailChange}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer className="d-flex justify-content-between">
                        <Button color="black" variant="secondary" disabled={isLoadingUpload} onClick={handleThumbnailClose}>
                            Cancel
                        </Button>
                        <Button
                            variant="success"
                            color="orange"
                            loading={isLoadingUpload}
                            onClick={handleThumbnailUpload}
                            disabled={!thumbnailModal.file}
                        >
                            Upload
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Modal for Content Upload */}
                <Modal
                    show={contentModal.show}
                    onHide={handleContentClose}
                    size="lg"
                    centered
                    backdrop="static"
                    keyboard={true}
                >
                    <Modal.Header closeButton={!isLoadingUpload}>
                        <Modal.Title>Upload Image Content</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row className="mb-3 d-flex justify-content-evenly">
                            {/* Old Content */}
                            {contentModal.oldFile && (
                                <Col md={6} className="text-center">
                                    <h6>Current Content Image</h6>
                                    <Image
                                        src={contentModal.oldFile}
                                        alt="Old Content"
                                        fluid
                                        rounded
                                        style={{ maxHeight: "200px", objectFit: "cover", border: "1px solid #ddd", padding: "5px" }}
                                    />
                                </Col>
                            )}

                            {/* New Content Preview */}
                            <Col md={6} className="text-center">
                                <h6>New Image Preview</h6>
                                {contentModal.preview ? (
                                    <Image
                                        src={contentModal.preview}
                                        alt="Preview"
                                        fluid
                                        rounded
                                        style={{ maxHeight: "200px", objectFit: "cover", border: "1px solid #ddd", padding: "5px" }}
                                    />
                                ) : (
                                    <div
                                        style={{
                                            height: "200px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            border: "1px dashed #ccc",
                                            borderRadius: "5px",
                                            color: "#999",
                                        }}
                                    >
                                        Preview will appear here
                                    </div>
                                )}
                            </Col>
                        </Row>

                        {/* File Upload */}
                        <Row className="mt-3">
                            <Col>
                                <Form.Group>
                                    <Form.Label>Select New Image</Form.Label>
                                    <Form.Control
                                        type="file"
                                        accept="image/*"
                                        onChange={(e) => {
                                            const file = e.target.files[0];
                                            if (file) {
                                                if (file.size > 1024 * 1024) {
                                                    errorAlert("File is too large!", null, "Please upload an image smaller than 1 MB.")
                                                    setContentModal({ ...contentModal, file: null });
                                                    e.target.value = "";
                                                } else {
                                                    handleContentChange(e)
                                                }
                                            }
                                        }}
                                    // onChange={handleContentChange}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer className="d-flex justify-content-between">
                        <Button color="black" variant="secondary" disabled={isLoadingUpload} onClick={handleContentClose}>
                            Cancel
                        </Button>
                        <Button
                            variant="success"
                            color="orange"
                            loading={isLoadingUpload}
                            onClick={handleContentUpload}
                            disabled={!contentModal.file}
                        >
                            Upload
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Modal Add/Edit */}
                <Modal show={showModal} onHide={handleClose} size="xl">
                    <Modal.Header closeButton={!isLoadingSubmit}>
                        <Modal.Title>{editData ? "Edit Blog" : "Add Blog"}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form
                            key={editData ? editData.id : "new"}
                            onSubmit={onSubmit}
                            encType="multipart/form-data"
                        >
                            <Form.Group className="mb-3">
                                <Form.Label>Title</Form.Label>
                                <Form.Control
                                    name="title"
                                    defaultValue={editData?.title || ""}
                                    required
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Content</Form.Label>
                                <Dimmer active={loadingContent} inverted>
                                    <Loader>Loading Content...</Loader>
                                </Dimmer>
                                <ReactQuill
                                    theme="snow"
                                    value={content}
                                    onChange={setContent}
                                    modules={quillModules}
                                    formats={quillFormats}
                                    style={{ height: "300px", marginBottom: "50px" }}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Meta Title</Form.Label>
                                <Form.Control
                                    name="meta_title"
                                    defaultValue={editData?.meta_title || ""}
                                    required
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Meta Description</Form.Label>
                                <Form.Control
                                    name="meta_description"
                                    defaultValue={editData?.meta_description || ""}
                                    required
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>{editData ? "Modifier" : "Author"}</Form.Label>
                                <Form.Control
                                    name={editData ? "modifier" : "author"}
                                    defaultValue={editData ? session?.name : ""}
                                    required
                                    disabled={editData}
                                />
                            </Form.Group>
                            <Row className="mb-3">
                                <Col md={4}>
                                    <Form.Label>Publish Date</Form.Label>
                                </Col>
                                <Col md={8}>
                                    {/*
                                    <DateRangePicker
                                        className="w-100"
                                        style={{ textAlign: "center" }}
                                        format="yyyy-MM-dd"
                                        placement="auto"
                                        cleanable
                                        defaultValue={dateRangeForm}
                                        value={dateRangeForm}
                                        onOk={handleChangeDateForm}
                                        onClean={() =>
                                            setDateRangeForm([
                                                new Date(moment().startOf("month")),
                                                new Date(moment()),
                                            ])
                                        }
                                        popupStyle={{ zIndex: 2000 }}
                                    />
                                    */}
                                    <DatePicker
                                        className="w-100"
                                        format="yyyy-MM-dd"
                                        placement="auto"
                                        cleanable
                                        value={publishDate}
                                        onChange={handleChangePublishDate}
                                        popupStyle={{ zIndex: 2000 }}
                                    />
                                </Col>
                            </Row>

                            {editData && (
                                <Form.Group className="mb-3">
                                    <Form.Label>Status</Form.Label>
                                    <Form.Select name="is_active" defaultValue={editData?.is_active || "1"}>
                                        <option value="1">Active</option>
                                        <option value="0">Inactive</option>
                                    </Form.Select>
                                </Form.Group>
                            )}

                            {/* Tampilkan upload file hanya jika tambah data */}
                            {!editData && (
                                <>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Thumbnail Image</Form.Label>
                                        <Form.Control
                                            type="file"
                                            name="thumbnail"
                                            accept="image/*"
                                            onChange={(e) => {
                                                const file = e.target.files[0];
                                                if (file) {
                                                    if (file.size > 1024 * 1024) {
                                                        errorAlert("File is too large!", null, "Please upload an image smaller than 1 MB.")
                                                        e.target.value = "";
                                                        setThumbnail(null);
                                                    } else {
                                                        setThumbnail(file);
                                                    }
                                                }
                                            }}
                                            required
                                        />
                                    </Form.Group>

                                    <Form.Group className="mb-3">
                                        <Form.Label>Content Image</Form.Label>
                                        <Form.Control
                                            type="file"
                                            name="content"
                                            accept="image/*"
                                            onChange={(e) => {
                                                const file = e.target.files[0];
                                                if (file) {
                                                    if (file.size > 1024 * 1024) {
                                                        errorAlert("File is too large!", null, "Please upload an image smaller than 1 MB.")
                                                        e.target.value = "";
                                                        setContentImage(null);
                                                    } else {
                                                        setContentImage(file);
                                                    }
                                                }
                                            }}
                                            required
                                        />
                                    </Form.Group>
                                </>
                            )}

                            <div className="text-end">
                                <Button type="button" disabled={isLoadingSubmit} color="black" onClick={handleClose} content="Cancel" />
                                <Button type="submit" loading={isLoadingSubmit} color="orange" content="Save" className="ms-2" />
                            </div>
                        </Form>
                    </Modal.Body>
                </Modal>

            </Container>
    );
};

export default Blog;
